let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cdvKS")).then(() => parcelRequire('7swxR'));